import { useQuery } from '@tanstack/react-query';
import { CHECKED_IN_NOW_QUERY_KEY, checkedInNowApi } from '../api/checkedInNow.api.js';

/**
 * How many people are ON THE CLOCK right now, anywhere — the rail's Overview
 * badge and the Overview's "Checked in now" tile, one query observed by both
 * (`routes/dashboard/checkedInNow.ts`).
 *
 * It was the per-site board's sum until 2026-10-29, which never counted a
 * remote or office punch with no worksite (owner: "they remotely attendance
 * but still part of attendance number!"). The per-site counts — the
 * Worksites rail, the map — still read `/site-ops/live-headcount`.
 *
 * IT POLLS, every 30s while the tab is in front: a count beside a pulsing dot
 * claims to be current. `null` is "not known" — first paint, a failed request,
 * a disabled reader — and never a 0 (rule 3.3).
 */
export function useCheckedInNowCount(options: { enabled?: boolean } = {}): number | null {
  const { data, isError } = useQuery({
    queryKey: CHECKED_IN_NOW_QUERY_KEY,
    queryFn: checkedInNowApi.get,
    refetchInterval: 30_000,
    refetchIntervalInBackground: false,
    enabled: options.enabled ?? true,
  });
  if (isError || !data) return null;
  return data.count;
}
